import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackAbroadOrderList from '../entities/order-back-list'

interface BackAbroadOrderState extends ListState<BackAbroadOrderList> {

}

class BackAbroadOrderMutations extends ListMutations<BackAbroadOrderList>{

}
class BackAbroadOrder extends ListModule<BackAbroadOrderState, any, BackAbroadOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackAbroadOrderList>(),
        loading: false,
        updateOrdeData: null,
        ids: [],
        BaseSkuNums: 0,
        ordertype: 0,
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<BackAbroadOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontAdvanceOrder/GetOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackAbroadOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async ComfirmInputRallow(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontAdvanceOrder/ComfirmInputRallow?warehouseId=' + payload.data.warehouseId);
        },
        async CancelInputRallow(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontAdvanceOrder/CancelInputRallow?warehouseId=' + payload.data.warehouseId);
        },
    };
    mutations = {
        setCurrentPage(state: BackAbroadOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackAbroadOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const BackAbroadOrderlist = new BackAbroadOrder();
export default BackAbroadOrderlist;